import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider, RequireAdmin, RequireAuth } from './auth';
import { DashboardLayout } from './components/Layout';
import Landing from './pages/Landing';
import Login from './pages/Login';
import CheckEmail from './pages/CheckEmail';
import AuthError from './pages/AuthError';
import LinkDevice from './pages/LinkDevice';
import Dashboard from './pages/Dashboard';
import Tokens from './pages/Tokens';
import Publish from './pages/Publish';
import Devices from './pages/Devices';
import Settings from './pages/Settings';
import Admin from './pages/Admin';

function Dash({ children }: { children: React.ReactNode }) {
  return (
    <RequireAuth>
      <DashboardLayout>{children}</DashboardLayout>
    </RequireAuth>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* public */}
          <Route path="/" element={<Landing />} />

          {/* auth flow */}
          <Route path="/auth/login" element={<Login />} />
          <Route path="/auth/check-email" element={<CheckEmail />} />
          <Route path="/auth/error" element={<AuthError />} />
          <Route path="/auth/link-device" element={<LinkDevice />} />

          {/* dashboard (auth-gated) */}
          <Route path="/dashboard" element={<Dash><Dashboard /></Dash>} />
          <Route path="/dashboard/tokens" element={<Dash><Tokens /></Dash>} />
          <Route path="/dashboard/publish" element={<Dash><Publish /></Dash>} />
          <Route path="/dashboard/devices" element={<Dash><Devices /></Dash>} />
          <Route path="/dashboard/settings" element={<Dash><Settings /></Dash>} />
          <Route
            path="/dashboard/admin"
            element={
              <RequireAdmin>
                <DashboardLayout>
                  <Admin />
                </DashboardLayout>
              </RequireAdmin>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
